/**
 *
 * @param { String } FILE_URL Url of script to load
 * @param { Boolean } async If true, the script is loaded asynchronously
 * @param { String } type Type of the script tag
 * @returns Promise
 */
export const loadScript = (
  FILE_URL,
  async = true,
  type = "text/javascript"
) => {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement("script");

    scriptElement.type = type;
    scriptElement.async = async;
    scriptElement.src = FILE_URL;

    scriptElement.onload = resolve;
    scriptElement.onerror = reject;
    document.head.appendChild(scriptElement);
  });
};

/**
 * Sustituya a loadScriptAsync o loadScript
 * @param {String} url La url de la librería a cargar
 * @returns Una promesa de cada carga de la librería
 */
export function loadLib(url, idTag) {
  return new Promise((resolve, reject) => {
    globalThis.idTagDelio = idTag
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => {
      let timeKill=setTimeout(()=>{
        clearTimeout(timeKill)
        resolve("carga D1C"); // Carga
      },1000)
      
    };
    script.onerror = reject; // No carga
    document.head.appendChild(script);
  });
}

export function loadLibTimeOut(url, idTag) {
  return new Promise((resolve, reject) => {
    globalThis.idTagDelio = idTag
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => {
      let timeKill=setTimeout(()=>{
        clearTimeout(timeKill)
        resolve("carga whatsapp"); // Carga
      },1000)

    };
    script.onerror = reject; // No carga
    document.head.appendChild(script);
  });
}

/**
 * 
 * @param {Array} libs Array de objetos con las librerías a cargar
 */
export async function loadAllLibs(libs) {


  try {
    console.log('entro aqui por')
    const promises = libs.map(lib => loadLib(lib.url))
    await Promise.all(promises)
  } catch (error) {
    console.error(errorWalmeric)
  }

}


/**
 *
 * @param { Array } arrayPromises Array of Promises to resolve
 * @returns response
 */

export const loadMultiScript = async (arrayPromises) => {
  try {
    const promises = await Promise.all(arrayPromises);
    return promises;
  } catch (error) {
    console.log(error);
  }
};


export const getVisitorId = ()=>{
  return new Promise((resolve, reject) => {
    setInterval(() => {
      if (globalThis.Piwik) {
        // @ts-ignore
        clearInterval()
        const idVisitor = globalThis.Piwik.getAsyncTracker().getVisitorId()
        resolve(idVisitor) 
      } else {
        reject(new Error('Piwik no existe '))
      }
    },1000)
  })
}